import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const itemKeys = {
    container: generateAutomationName("activation", ["setup", "ai", "competitors", "website", "item", "container"]),
    name: generateAutomationName("activation", ["setup", "ai", "competitors", "website", "item", "name"]),
    suggestedReason: generateAutomationName("activation", [
        "setup",
        "ai",
        "competitors",
        "website",
        "item",
        "suggested",
        "reason",
    ]),
    btn: generateAutomationName("activation", ["setup", "ai", "competitors", "website", "item", "button"]),
};
